module.exports = __webpack_public_path__ + "img/icon_compare.f9496685.svg";